import { DefaultTemplate } from "./templates";

export default class InfoModal extends DefaultTemplate {
    renderBody = () => {
        return this.props.body;
    };
}
